import { EmailCampaignStatus } from "@/types/email";

interface CampaignStatusBadgeProps {
  status: EmailCampaignStatus;
  className?: string;
}

function getStatusStyles(status: EmailCampaignStatus): string {
  switch (status) {
    case EmailCampaignStatus.Draft:
      return "bg-yellow-500/10 text-yellow-500";
    case EmailCampaignStatus.Scheduled:
      return "bg-blue-500/10 text-blue-500";
    case EmailCampaignStatus.Sending:
      return "bg-blue-500/10 text-blue-500";
    case EmailCampaignStatus.Sent:
      return "bg-green-500/10 text-green-500";
    case EmailCampaignStatus.Paused:
      return "bg-orange-500/10 text-orange-500";
    case EmailCampaignStatus.Failed:
      return "bg-destructive/10 text-destructive";
    case EmailCampaignStatus.Cancelled:
      return "bg-muted text-muted-foreground";
    default:
      return "bg-muted text-muted-foreground";
  }
}

export function CampaignStatusBadge({ status, className = "" }: CampaignStatusBadgeProps) {
  const isSending = status === EmailCampaignStatus.Sending;
  return (
    <span
      className={`lw-campaign-status-badge inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium ${getStatusStyles(status)} ${className}`}
    >
      {isSending && (
        <span className="h-1.5 w-1.5 rounded-full bg-current animate-pulse" />
      )}
      {status}
    </span>
  );
}
